export const INCORRECT_LINK = 'The URL is incorrect';
